<p-drawer
    [open]="errorMessages.showMessage()"
    (closed)="onVisibleChange(false)"
    [title]="'validation.validationErrors' | translate"
    [showClose]="true"
    position="right"
    size="sm">

    <div class="p-4 h-full overflow-auto [&::-webkit-scrollbar]:hidden">
        <div class="flex flex-col space-y-3">
            @for (message of errorMessages.messages(); track message) {
                <div class="rounded-lg px-3 py-2 text-sm" [style.background]="severityStyle(message.severity).background" [style.color]="severityStyle(message.severity).color">
                    {{ message.text }}
                </div>
            }
        </div>
    </div>
</p-drawer>
